(function() {

  function fixPrices() {
    document.querySelectorAll('.f-price .money').forEach(function(el) {
      var text = el.textContent.trim();
      text = text.replace(/Rs\.\s*/gi, '');
      text = text.replace(/\.00$/, '');
      text = text.replace(/,00$/, '');
      if (!text.startsWith('₹')) {
        text = '₹' + text;
      }
      el.textContent = text;
    });
  }

  /* RUAAB 17 Jul: mobile multi-image swipe track DISABLED. It moved every card img
     into .ruaab-card-track, but that track's CSS lived in the dormant (never-linked)
     ruaab-custom.css, so images stacked unstyled = mobile glitch. Cards now show the
     single featured image on mobile (desktop keeps native hover-swap). fixPrices stays. */
  function run() {
    fixPrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.addedNodes.length > 0) { run(); }
    });
  });

  var grid = document.getElementById('ProductsList');
  if (grid) { observer.observe(grid, { childList: true, subtree: true }); }

})();